module.exports = __webpack_public_path__ + "static/media/scan-1.29d52634.jpg";